Vue.component('chat-audio', {
	props: ['options'],
	template: '<transition v-if="isActive" name="bounce" enter-active-class="bounceInLeft" leave-active-class="bounceOutRight" v-bind:css="options.internal.isAnimationCompatibility">' +
		'<div id="audio" :class="{ \'escalation\': hasEscalation }">' +
		'<button v-if="isAllowClose" class="close-media"  @click="closeMedia"><i class="material-icons">&#xE5C9;</i></button>' +
		'<div v-if="options.isChatOnlyAudio">' +
		'<img :src="getImgAgent()"  :class="{ \'trasfering\': inTransfer }" class="img-agent img-responsive"  onerror="svgOnError()">' +
		'<p v-if="getAgentName()" class="agent-name" :class="{ \'trasfering\': inTransfer }" :title="getAgentName()" >{{ getAgentName() }}</p>' +
		'</div>' +
		'<div id="mediabox" class="mediabox">' +
		'</div>' +
		'</transition>',
	data: function () {
		return {
			isActive: false,
			isf2f: true,
			hasEscalation: false,
			msg: '',
			iconLoader: '../img/loader.svg',
			isAllowClose: false,
			inTransfer: false,
			agentName: ''
		}
	},
	mounted: function () {
		var that = this;

		bus.$on('onAudioEscalation', function (val) {
			that.contentShow(val);
			that.setEscalation(val)

		});

		bus.$on('isRingingEvent', function (val) {
			if (val.options.info_agent[0]["Remote-Party-ID"] == "") {
				that.agentName = that.options.internal.agentDisplayName;
			} else {
				that.agentName = val.options.info_agent[0]["Remote-Party-ID"];
			}
		});

		bus.$on('isQueuedEvent', function (val) {
			if (val.options.info_agent[0]["Remote-Party-ID"] == "") {
				that.agentName = that.options.internal.agentDisplayName;
			} else {
				that.agentName = val.options.info_agent[0]["Remote-Party-ID"];
			}
		});

		bus.$on('isRunningEvent', function (val) {
			if (val.options.info_agent[0]["Remote-Party-ID"] == "") {
				that.agentName = that.options.internal.agentDisplayName;
			} else {
				that.agentName = val.options.info_agent[0]["Remote-Party-ID"];
			}
		});

		bus.$on('isF2F', function (val) {
			that.isf2f = val;
		});

		this.$parent.$on('onVideoEscalation', function (val) {
			that.contentShow(val);
			that.setEscalation(val)
		});

		this.$parent.$on('onAudioShow', function (val) {
			that.contentShow(val);
		});

		this.$parent.$on('onRecording', function (val) {
			that.startRecording(val);
		});

		this.$parent.$on('isRingingEvent', function (val) {
			if (val.options.info_agent[0]["Remote-Party-ID"] == "") {
				that.agentName = that.options.internal.agentDisplayName;
			} else {
				that.agentName = val.options.info_agent[0]["Remote-Party-ID"];
			}
		});

		this.$parent.$on('isQueuedEvent', function (val) {
			if (val.options.info_agent[0]["Remote-Party-ID"] == "") {
				that.agentName = that.options.internal.agentDisplayName;
			} else {
				that.agentName = val.options.info_agent[0]["Remote-Party-ID"];
			}
		});

		this.$parent.$on('isRunningEvent', function (val) {
			if (val.options.info_agent[0]["Remote-Party-ID"] == "") {
				that.agentName = that.options.internal.agentDisplayName;
			} else {
				that.agentName = val.options.info_agent[0]["Remote-Party-ID"];
			}
		});

		this.$parent.$on('isF2F', function (val) {
			that.isf2f = val;
		});

	},
	methods: {
		svgOnError:function(){
			console.log('Fail to load svg chat audio');
		},
		contentShow: function (val) {
			this.isActive = val;
		},
		setEscalation: function () {
			this.hasEscalation = true;
		},
		closeMedia: function () {
			bus.$emit("onEscalation", false);
			this.contentShow(false);

		},
		getAgentName: function () {
			// if(this.agentName != "") {
			// 	return this.agentName
			// } else {
			// 	return this.options.internal.agentDisplayName
			// }
			if (!this.isf2s) {
				return this.agentName;
			} else {
				return this.options.internal.agentDisplayName;
			}
		},
		getImgAgent: function () {
			if (this.options.isVirtualAgent == true) {
				return this.options.imgVirtualAgent;
			}
			else {
				return this.options.imgAgent;
			}
		},
		startRecording: function (val) {
			if (val == true) {
				Vue.nextTick(function () {
					if ($('#eu_media_remote').length > 0)
						$('<div id="rec_blink" class="blink"><i class="material-icons pull-left">&#xE3A6;</i><span>REC</span></div>').appendTo('#eu_media_remote');
					else if ($('#eu_media_wrapper').length > 0)
						$('<div id="rec_blink" class="blink"><i class="material-icons pull-left">&#xE3A6;</i><span>REC</span></div>').appendTo('#eu_media_wrapper');
				})
			} else {
				Vue.nextTick(function () {
					$('#rec_blink').remove();
				})
			}

		},

	}
})
